/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {decode} from 'html-entities';
import {reactLocalStorage} from 'reactjs-localstorage';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import {useSelector, useDispatch} from 'react-redux';
import { _action_user } from '../../../redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../../style/general/node.entry.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/

import { random_character, countDown } from '../../../functions'

const Screen = ({loading, error, location}) => {

    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}

    const [username, set_username] = useState('');

    const [refresh, set_refresh] = useState(false);

    const [second, set_second] = useState(0);

	//#region redux ------------------------------------------------

	const dispatch = useDispatch();

    const redux_user = useSelector(state => state.user);

	const _set_redux_user = (data) => {
		dispatch(_action_user(data, 'data'))
	}

	//#endregion redux ---------------------------------------------

    const _send = () => {

        if(loading === true){
            return
        }

		loading(true);

		API_GET_PUBLIC('activation__________?key=' + random_character(32)
			+ '&action=send'
            + '&username=' + username
        , 
	    ).then((response) => {
            console.log('------', response.data)
			if(response.data.result === 'success'){
                countDown('30', (e) => {
                    set_second(e)
                })
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }

    const _activation = (usernameParams) => {

        console.log('username params : ', usernameParams)

        if(loading === true){
            return
        }

		loading(true);

		API_GET_PUBLIC('activation__________?key=' + random_character(32)
			+ '&action=verification'
            + '&username=' + usernameParams 
        , 
	    ).then((response) => {
            console.log('------', response)
			if(response.data.result === 'success'){
                reactLocalStorage.clear();
                _set_redux_user('')
                set_refresh(false)
            }else if(response.data.error){
                // error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }

    const _STORAGE_USER = () => {

        let username = STORAGE_USER[0].username;
        
        if(username){
            _activation(username)
            set_username(username)
        }

    }
    
    useEffect(() => {

        reactLocalStorage.clear();

    }, [refresh])

    return (
        <>
            <div className="_bb-background"></div>
            <div className="_bb_background_2"></div>
            <div className="_container _relative">
                <div className="__section_pages_title">
                    <div className="_row _center_align _lily_pad_h_d">
                        <div className="_column">
                            <h1>Redirect</h1>
                            <p style={{maxWidth: 500}}>Selamat pendaftaran Anda telah di Verifikasi, silahkan 
                                <NavLink 
                                    to={{
                                        pathname: "/forum/login",
                                    }}
                                    // activeClassName="__nav_active"
                                    style={{color: '#118ab2', marginLeft: 4, marginRight: 4}}
                                >
                                    Login
                                </NavLink>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default Screen;